<template>
  <div class="entryList">
    <b-container>
      <b-row v-if="title" >
        <b-col md="1"></b-col>
        <h3>{{title}}</h3>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-col md="10">
          <h6 v-if="text" class="text-left">{{text}}</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <ul>
          <li v-for="listItem in list" :key="listItem.listItemId">
            <h6 class="left">{{listItem.text}}</h6>
          </li>
        </ul>
      </b-row>
      <b-row v-if="graphic" >
        <b-col md="2"></b-col>
        <b-col md="8">
          <div>
            <b-img :src="graphic" thumbnail fluid class="thumbnail"/>
          </div>
        </b-col>
        <b-col md="2"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'entryList',
  props: {
    contentId: Number,
    title: String,
    text: String,
    graphic: String,
    list: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EntryList.vue